<template>
  <div class="container-card-item">
    <div class="container-card">
      <div class="circle-icon">
        <div class="container-icon">
          <i v-if="image.icon === true" :class="[image.value, 'icofont']"></i>
          <img v-else class="image" :src="image.value" />
        </div>
      </div>
      <div class="container-texts">
        <div class="title">{{ title }}</div>
        <div class="subtitle">{{ subtitle }}</div>
      </div>
      <div class="container-button">
        <download-excel
          class="export"
          :fetch="generateFile"
          :fields="fields"
          :worksheet="itemsXls.worksheet"
          :name="itemsXls.name"
        >
          <v-btn
            :loading="loading"
            :disabled="loading"
            readonly="loading"
            class="d-block button"
            variant="tonal"
            elevation="1"
            >{{ textDownload }}</v-btn
          >
        </download-excel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardExport',
  props: {
    itemsXls: {
      type: Object,
      default: () => ({ worksheet: '', name: '' }),
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    textDownload: {
      type: String,
      default: 'Download',
    },
    image: {
      type: Object,
      default: () => ({ icon: true, value: '' }),
    },
    endpoint: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      fields: {},
      dataFields: [],
    }
  },
  methods: {
    transformToSameKeyValue(obj) {
      const transformedObj = {}
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          transformedObj[key] = key
        }
      }
      return transformedObj
    },
    addFieldWithZeroCheck(obj, key) {
      obj[key] = {
        callback: (value) => {
          if (
            value[key] !== '' &&
            value[key] !== null &&
            value[key] !== undefined
          ) {
            return `​  ​​${value[key].toString()}`
          } else {
            return ''
          }
        },
      }
    },
    isDataNoFormatoISO(valor) {
      const regexDataISO = /^\d{4}-\d{2}-\d{2}$/
      return regexDataISO.test(valor)
    },
    brLocaleFormat(dataISO) {
      const [ano, mes, dia] = dataISO.split('-')
      return `${dia}/${mes}/${ano}`
    },
    async generateFile() {
      this.loading = true
      try {
        let response = await this.$api.get(this.endpoint)

        if (response) {
          this.fields = {}

          this.dataFields = response.data
          this.dataFields.forEach((obj) => {
            for (const key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const value = obj[key]
                if (this.isDataNoFormatoISO(value)) {
                  obj[key] = this.brLocaleFormat(value)
                }
              }
            }
          })

          this.fields = this.transformToSameKeyValue(response.data[0])
          this.addFieldWithZeroCheck(this.fields, 'nu_cpf')
          this.addFieldWithZeroCheck(this.fields, 'nu_ine')
          this.addFieldWithZeroCheck(this.fields, 'nu_cns')

          this.$toast.success('Arquivo gerado com sucesso!', 'Sucesso:', {
            position: 'topRight',
          })

          return this.dataFields
        }
      } catch (error) {
        this.$toast.error(error, 'Error:', {
          position: 'topRight',
        })
        return
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
